
import { defineComponent, PropType } from "vue";
import { Transcript, TranscriptWord } from "@/models/transcript";

interface TranscriptionsComponentData {
    activeWords?: string;
}

export default defineComponent({
    name: "TranscriptionsComponent",
    data(): TranscriptionsComponentData {
        return {
            activeWords: undefined,
        };
    },
    props: {
        currentTime: { type: Number, required: true },
        transcript: { type: Object as PropType<Transcript>, required: true },
        rolling: { type: Boolean, required: false },
    },
    watch: {
        currentTime() {
            // find current segment & assign activeWords & inactveWords
            this.buildActiveWords();
        },
        transcript() {
            // build all segments & save to data.segements
            this.buildActiveWords();
        },
    },
    mounted() {
        this.buildActiveWords();
    },
    methods: {
        buildActiveWords(): void {
            let activeWords = "";
            for (let i = 0; i < this.transcript.words.length; i++) {
                const element: TranscriptWord = this.transcript.words[i];
                let wordContent: string = this.transcript.words[i].content;

                // check if next word is punctuation and add it to the current word
                const nextWord: TranscriptWord | undefined = this.transcript.words[i + 1];
                if (nextWord && this.isWordPunctuation(nextWord)) {
                    wordContent += nextWord.content;
                }

                if (this.isWordPunctuation(element)) {
                    continue;
                }

                const timeStart = element.timeStart || 0;

                if (this.currentTime > timeStart) {
                    if (activeWords !== "") {
                        activeWords += " ";
                    }
                    activeWords += wordContent;
                }
            }

            this.activeWords = activeWords;
        },

        isWordPunctuation(word: TranscriptWord): boolean {
            return word.timeStart === undefined || word.timeStart === null;
        },
    },
});
